/**
 * BetterError just Error with extra data inside.
 * We can transfer extra information about error up to the stack.
 * @extends Error
 */
class BetterError extends Error {
  constructor(message, customData) {
    super(message)

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, BetterError)
    }

    this.data = customData
  }
}

export default BetterError
